import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store.js';
import { sync } from 'vuex-router-sync';
import $ from 'jquery';
import VueI18n from 'vue-i18n';
import messages from './translation/messages';
// TODO: turn on serviceWorker
//import "./registerServiceWorker";
//import 'es6-promise/auto' //Promise polyfill

Vue.config.productionTip = false;

// Spritespin + jQuery
window.$ = $;
const SpriteSpin = require('spritespin');

// Vuex with router sync
const unsync = sync(store, router);

// Translations
Vue.use(VueI18n);
let i18n;
if (window.location.pathname.includes('en')) {
  i18n = new VueI18n({ messages, locale: 'en' });
} else if (window.location.pathname.includes('de')) {
  i18n = new VueI18n({ messages, locale: 'de' });
} else {
  i18n = new VueI18n({ messages, locale: 'pl' });
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
